import { Component } from '@angular/core';
import { SUPPORT_CONTACTS, SUPPORT_OFFICE_NOTE } from '../../constants/support-contact.constants';

@Component({
  selector: 'app-support-contact-panel',
  templateUrl: './support-contact-panel.component.html',
  styleUrls: ['./support-contact-panel.component.scss'],
})
export class SupportContactPanelComponent {
  readonly contacts = SUPPORT_CONTACTS;
  readonly officeNote = SUPPORT_OFFICE_NOTE;
}
